import icBack24 from './icon/ic_back_24.svg'
import icPin24 from './icon/ic_pin_24.svg'
import icPlane36 from './icon/ic_plane_36.svg'
import icClose24 from './icon/ic_close_24.svg'

export default {
    icBack24,
    icPin24,
    icPlane36,
    icClose24
}